import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { ActivatedRoute,Router } from '@angular/router';
import {InvoicesService} from "../services/invoices.service";
import {FolderModel} from "../models/folder.model";
import {FileUploadService} from "../../../../services/file-upload.service";
import * as saveAs from 'file-saver';
import { Auth } from 'aws-amplify';


interface Folder {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-run-process',
  templateUrl: './run-process.component.html',
  styleUrls: ['./run-process.component.css']
})
export class RunProcessComponent implements OnInit {
  newFolder!: UntypedFormGroup;
  documentData: any;
  name!: string;
  url!: string;
  listOfFolders: FolderModel[] = [];
  selectedFolder!: FolderModel;
  selectedFoldersInvoices: any = [];
  value = 40;
  isProgress = false;
  res: any
  isProcessDone = false
  subscriptionResponse: any
  user: any


  constructor(private formBuilder: UntypedFormBuilder,private router: Router, private invoiceService: InvoicesService, private fileUploadService: FileUploadService) {
    this.newFolder = this.formBuilder.group({
      name:[null, Validators.required]
    });
  }

  async ngOnInit(): Promise<void> {
    this.user = await Auth.currentAuthenticatedUser()
    this.invoiceService.ListFolders({clientID: {eq: this.user.attributes.sub}}).then(data => {
      data.items.forEach((el: any) => {
        if (el) {
          this.listOfFolders.push(new FolderModel(el.id, el.clientID, el.createdAt, el.invoices, el.name, el.updatedAt))
        }
      })
    }).catch((err) => console.log(err));
    this.activateSubscriptions()
  }

  close(){
    this.router.navigate(['/invoices'])
  }

  activateSubscriptions() {
    this.invoiceService.OnUpdateFolderListener(this.user.attributes.sub).subscribe((evt: any) => {
      if (evt.value.data.onUpdateFolder.id === this.selectedFolder.id) {
        this.isProgress = false
        this.isProcessDone = true
        this.subscriptionResponse = evt.value.data.onUpdateFolder
      }
    })
  }

  setFolder(folder: any) {
    this.selectedFolder = folder
  }

  async getZipFile() {
    this.isProcessDone = false
    this.isProgress = true
    this.selectedFolder.invoices.items.forEach((el: any) => {
      this.selectedFoldersInvoices.push({invoiceName: el.name, folderID: el.folderID})
    })
    this.invoiceService.RunFolder(this.selectedFoldersInvoices)
  }


  async downloadFile() {
    if (this.selectedFolder.id === this.subscriptionResponse.id) {
      let arrayBuffer = this.subscriptionResponse.downloadLink // Note: not oReq.responseText

      const linkSource = arrayBuffer;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      const urlPath = linkSource.split('?')[0];
      const filename = decodeURIComponent(urlPath.split('/').pop() || 'archive.zip');
      downloadLink.download = filename;
      downloadLink.click();
    }
  }
  templates: Folder[] = [
    {value: '0', viewValue: 'Template(1)'},
    {value: '1', viewValue: 'Template(2)'},
    {value: '2', viewValue: 'Template(3)'},
    {value: '3', viewValue: 'Template(4)'},
  ];

}
